import { DatePicker, Form, FormInstance, Input, Select } from "antd";
import moment from "moment";
import React from "react";
import { useGetAllCustomersQuery } from "../../generated/types";
import { Project } from "./ProjectsTableContainer";
import styles from "./styles.module.css";

interface CustomerEditorProps {
  customers: string[];
  projects: Project[];
  form: FormInstance;
  setSelectedCustomer: (customer: string) => void;
  selectedCustomer: string | null;
}

export const CustomerEditor = (props: CustomerEditorProps) => {
  const { customers, projects, form, setSelectedCustomer, selectedCustomer } =
    props;

  const { data: customersData, loading: customersLoading } =
    useGetAllCustomersQuery();
  const customerProjects = projects.filter(
    (p) => p.customer === selectedCustomer,
  );
  const projectsCompleted = customerProjects.filter(
    (p) => p?.isCompleted,
  ).length;
  const projectsTracking = customerProjects.filter((p) => p?.isTracking).length;
  const projectsTotal = customerProjects.length;

  const handleCustomerChange = (value: string) => {
    setSelectedCustomer(value);
    form.setFieldsValue({
      selectedCustomer: value,
    });

    const customerData = customersData?.customers?.find(
      (c) => c.customer === value,
    );
    if (customerData) {
      form.setFieldsValue({
        selectedCustomer: value,
        name: customerData.name,
        collabStarted: customerData.collabStarted
          ? moment(customerData.collabStarted)
          : null,
        imagesCaptured: customerData.imagesCaptured,
        upcomingProjects: customerData.upcomingProjects,
      });
    } else {
      form.resetFields();
    }
  };

  return (
    <div className={styles["editor-container"]}>
      <Form form={form} layout="vertical" className={styles["form-container"]}>
        <div className={styles["form-row"]}>
          <Form.Item
            label="Select Customer"
            name="selectedCustomer"
            className={styles["form-item"]}
          >
            <Select
              showSearch
              optionFilterProp="label"
              className={styles["form-item"]}
              onChange={handleCustomerChange}
              placeholder="Select a customer"
              loading={customersLoading}
              options={customers.map((customer) => ({
                label: customer,
                value: customer,
              }))}
            />
          </Form.Item>
          {selectedCustomer && (
            <>
              <Form.Item
                label="Customer Display Name"
                name="name"
                className={styles["form-item"]}
              >
                <Input placeholder="Enter customer name" />
              </Form.Item>
              <Form.Item
                label="Collaboration Started"
                name="collabStarted"
                className={styles["form-item"]}
              >
                <DatePicker
                  placeholder="Select collab start date"
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
              <Form.Item
                label="Images Captured"
                name="imagesCaptured"
                className={styles["form-item"]}
              >
                <Input placeholder="Enter images captured" />
              </Form.Item>
              <Form.Item
                label="Upcoming Projects"
                name="upcomingProjects"
                className={styles["form-item"]}
              >
                <Input type="number" placeholder="Enter upcoming projects" />
              </Form.Item>
            </>
          )}
          {selectedCustomer && (
            <>
              <div className={styles["project-stats-row"]}>
                <span className={styles["project-total-text"]}>
                  📋 {projectsTotal} Total
                </span>
                <span className={styles["project-completed-text"]}>
                  ✓ {projectsCompleted} Completed
                </span>
                <span className={styles["project-live-text"]}>
                  📊 {projectsTracking} Live
                </span>
              </div>
            </>
          )}
        </div>
      </Form>
    </div>
  );
};
